import env from "@beam-australia/react-env";
import { camelCase, get, map, some } from "lodash";
import type { RootState } from "types/state";

export const superAdminRole = camelCase("Icon Super Admin");
export const regularAdminRole = camelCase("Icon Admin");
export const employerAdminRole = camelCase("Icon Employer Admin");
export const salesAgentRole = camelCase("Icon Sales Agent");

export const getAdminRoles = (state: RootState): string[] => {
  const roleProperty = `https://${env("AUTH0_DOMAIN")}/roles`;
  const roles = get(state, `user.auth0User["${roleProperty}"]`, []) as string[];
  return map(roles, camelCase);
};

export const isSuperIconAdmin = (state: RootState): boolean => {
  const roles = getAdminRoles(state);
  return some(roles, (role) => role === superAdminRole);
};
export const isIconAdmin = (state: RootState): boolean => {
  const roles = getAdminRoles(state);
  return some(roles, (role) => role === regularAdminRole);
};
export const isIconEmployerAdmin = (state: RootState): boolean => {
  const roles = getAdminRoles(state);
  return some(roles, (role) => role === employerAdminRole);
};
export const isIconSalesAgent = (state: RootState): boolean => {
  const roles = getAdminRoles(state);
  return some(roles, (role) => role === salesAgentRole);
};
